import { Component, Inject, OnInit, Input, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Alert } from 'src/app/interfaces/alert';
import { Perk, PerkVoucherCode } from 'src/app/interfaces/perk';
import { PerkService } from 'src/app/services/perk/perk.service';
import { UserService } from 'src/app/services/user/user.service';
import { ClickEventNumbersEnum } from 'src/app/interfaces/clickEventNumbers';
import { isPlatformBrowser } from '@angular/common';

const VOUCHER_CODE_PLACEHOLDER = '{voucherCode}';

@Component({
  selector: 'app-perk-modal',
  templateUrl: './perk-modal.component.html',
  styleUrls: ['./perk-modal.component.scss'],
})
export class PerkModalComponent implements OnInit {
  @Input() perk: Perk;
  alert: Alert = null;
  loading = false;
  perkModalRef?: NgbModalRef;
  showVoucherCode = false;
  voucher: any = null;
  voucherHeading: string;
  perkEventData?: any;
  perkID: string;
  vaucherText: string;
  isBrowser: boolean;

  ClickEventNumbersEnum = ClickEventNumbersEnum;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private userService: UserService,
    private perkService: PerkService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  closeAlert() {
    this.alert = null;
  }

  copyVoucherCode(el) {
    el.select();
    if (this.isBrowser) {
      document.execCommand('copy');
    }
    el.setSelectionRange(0, 0);
    this.alert = {
      type: 'success',
      message: 'Voucher code copied to clipboard!',
    };
  }

  submitModal(): void {
    if (this.perk.voucher && !this.showVoucherCode) {
      this.issueOffer();
      this.revealVoucher();
    } else {
      if (!this.perk.voucher) {
        this.issueOffer();
      }
      if (this.perk.modal.button.route) {
        this.loading = true;
        this.router
          .navigate([this.perk.modal.button.route])
          .then(() => {
            this.trackEvent(
              `perksmodal::${this.perk.name}::gotopartnersite::clicked`,
              this.perkEventData
            );
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        if (this.isBrowser) {
          window.open(
            this.perk.voucher && this.perk.voucher.url
              ? this.perk.voucher.url
              : this.perk.modal.button.url,
            '_blank'
          );
        }
        this.activeModal.close();
      }
    }
  }

  private issueOffer(): void {
    if (this.perk.name === 'petplan') {
      this.trackEvent(`perksmodal::${this.perk.name}::applicationstarted`);
    } else {
      this.trackEvent(`perksmodal::${this.perk.name}::offerissued`, this.perkEventData);
    }
    if (this.perk.shortCode) {
      this.userService.sendVoucherEmail(this.perk.shortCode);
    }
  }

  private revealVoucher(): void {
    if (this.perk.voucher) {
      this.showVoucherCode = true;
    }
  }

  trackEvent(event: string, data?: any) {
    if (!this.isBrowser) return;
    window.analytics.track(event, data);
  }

  ngOnInit(): void {
    this.perkID = this.perk.name;

    if (this.perk.modal.copy.headingBottom) {
      this.vaucherText = this.perk.modal.copy.headingBottom.replace(VOUCHER_CODE_PLACEHOLDER, '');
    }
    if (this.perk.hasUniqueCode && this.perk.modal.copy.headingBottom?.includes(VOUCHER_CODE_PLACEHOLDER)) {
      this.perkService
        .getPerkVoucerCode(this.perk.shortCode)
        .subscribe((perkVoucherCode: PerkVoucherCode) => {
          this.vaucherText = this.perk.modal.copy.headingBottom.replace(
            VOUCHER_CODE_PLACEHOLDER,
            perkVoucherCode.PromotionCode
          );
        });
    }

    if (this.perk.tag) {
      this.perkID = this.perk.tag;
      this.perkEventData = {
        tag: this.perk.tag,
      };
    }
  }
}
